import {InfoSVG} from "../../../svg";
import React, {FC} from "react";
import cls from "./deliveryDays.module.scss"

interface ICustomDeliveryDays {
    deliveryDays: any;
    deliveryDateIntl: {
        date: string;
        days: string;
    };
}

const CustomDeliveryDays: FC<ICustomDeliveryDays> = (
    {
        deliveryDays,
        deliveryDateIntl
    }
) => {

    if (!deliveryDays) return null;

    return (
        <div className={cls["product__delivery_info"]}>
            <div>
                <InfoSVG/>
            </div>
            <div className={cls["product__delivery_date"]}>
                <span>{deliveryDateIntl.date} - </span> {deliveryDays + " " + deliveryDateIntl.days}
            </div>
        </div>
    )
}

export default CustomDeliveryDays;